import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/** Rani pink is the action color: it reads on both the ivory sections and the dark stage. */
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-5 text-lg sm:text-xl rounded-full min-h-[64px]' : 'px-5 py-3 text-sm rounded-full';
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 bg-teal text-center font-display tracking-tight text-white shadow-card transition-[background-color,box-shadow,transform] duration-150 ease-out hover:bg-teal-deep hover:shadow-lift active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-peach/60 ${sizing} ${className}`} data-id="element-84" data-mp="llh054kt4wpi">
      {children}
    </a>;
}